<script setup>
import useSharedData from "@/use/SharedData";
import axios from "axios";
import {defineEmits, defineProps, onMounted, ref, watch} from "vue";

const props = defineProps({
    value: [Number, Array],
    readonly: Boolean,
    disabled: Boolean,
    label: String,
    rules: Array,
    multiple: Boolean,
    type: String,
});

const emit = defineEmits(["input"]);

const {loading, inputColor, inputBackgroundColor} = useSharedData();
const frequencies = ref([]);
const frequency = ref(null);

function findFrequencies() {
    loading.value = true;
    axios.get(`/visits/findFrequencies`, {
        params: {type: props.type}
    }).then(response => {
        frequencies.value = response.data;
    }).finally(() => {
        loading.value = false;
    });
}

function input(value) {
    emit('input', value)
}

watch(() => props.value, () => {
    frequency.value = props.value;
}, {immediate: true});

onMounted(() => findFrequencies());
</script>

<template>
    <div>
        <v-autocomplete
            v-model="frequency"
            :items="frequencies"
            item-value="id"
            item-text="name"
            outlined
            dense
            :label="label"
            :color="inputColor"
            :background-color="inputBackgroundColor"
            :readonly="readonly"
            :disabled="disabled"
            :multiple="multiple"
            :loading="loading"
            :clearable="!readonly"
            @input="input"
            :rules="rules"
            hide-details="auto"
        ></v-autocomplete>

        <input type="hidden"/>
    </div>
</template>